import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { Container, Col, Button, Row } from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";
import MexicanCurrency from "../common/currency";
import DatePicker from "../common/DatePicker";
import s from "./styles.scss";
import IAction from "../../../types/IAction";
import { getClubsRequest } from "../../actions/catalogs";
import { handleRequestError } from "../../../utils/helpers";
import { getConciliacionCashBoxData } from "../../actions/billing";
import {
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});

function formatToCurrency(n) {
  return currencyFormatter.format(n || 0).replace("$", "");
}

interface Props {
  pdfCashCut: (data: object, clubId: string, fechaDePago: string) => IAction;
}

interface State {
  filters: object;
  clubsCatalog: any[];
  loading: boolean;
  data: any;
}

const START_DATE_FIELDNAME = "fechaInicio";

class ConciliacionCashCutReport extends React.Component<Props, State> {
  state = {
    clubsCatalog: [],
    filters: {
      idClub: null,
      fechaInicio: null
    },
    loading: false,
    data: null
  };

  componentDidMount() {
    this.getClubsCatalog();
  }

  getClubsCatalog = () => {
    getClubsRequest()
      .then(({ data }) => {
        this.setState({ clubsCatalog: data });
      })
      .catch(handleRequestError);
  };

  onChangeFilter = fieldName => {
    return event => {
      const value = event.target.value;
      this.setState(state => {
        const filters = {
          ...this.state.filters,
          [fieldName]: value
        };
        return { ...state, filters };
      });
    };
  };

  onChangeDate = fieldName => {
    return event => {
      const date = moment(event).format("YYYY-MM-DD");
      this.setState(state => {
        const filters = {
          ...state.filters,
          [fieldName]: date
        };
        return { ...state, error: {}, filters };
      });
    };
  };

  onChangeFields = fieldName => {
    return event => {
      const value = event.target.value;
      this.setState(state => {
        const filters = {
          ...state.filters,
          [fieldName]: value
        };

        return { ...state, error: {}, filters };
      });
    };
  };

  search = e => {
    e.preventDefault();
    const { idClub, fechaInicio } = this.state.filters;

    infoNotification("Consultando datos...");
    this.setState({ data: null, loading: true });

    getConciliacionCashBoxData(idClub, fechaInicio)
      .then(({ data }) => {
        this.setState({ data, loading: false });
        successNotification("Datos consultados correctamente...");
      })
      .catch(err => {
        handleRequestError(err);
        this.setState({ data: null, loading: false });
      });
  };

  generarPDF = e => {
    e.preventDefault();

    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const day = new Date().getDate();
    const hours = new Date().getHours();
    const minutes = new Date().getMinutes();
    const seconds = new Date().getSeconds();
    const { idClub, fechaInicio } = this.state.filters;

    const {
      facturacion,
      facturacionTotal,
      conciliacion,
      conciliacionMas,
      conciliacionTotal,
      conciliacionMasTotal,
      cobranza,
      cobranzaTotal
    } = this.state.data;

    const saldoConciliado =
      facturacionTotal + conciliacionMasTotal - conciliacionTotal;

    this.props.pdfCashCut(
      {
        nuevaVersion: true,
        clubId: idClub,
        clubNombre:
          (this.state.clubsCatalog.find(x => x.clubId == idClub) || {})
            .nombre || "",
        pagosFacturados: [
          {
            concepto: "Efectivo",
            monto: facturacion.efectivo || 0
          },
          {
            concepto: "Cheque",
            monto: facturacion.cheque || 0
          },
          {
            concepto: "CAT Visa/Mastercard",
            monto: facturacion.cargoAutomaticoVisaMc || 0
          },
          {
            concepto: "CAT American Express",
            monto: facturacion.cargoAutomaticoAmex || 0
          },
          {
            concepto: "TPV Visa/Mastercard",
            monto: facturacion.cargoDirectoVisaMc || 0
          },
          {
            concepto: "TPV American Express",
            monto: facturacion.cargoDirectoAmex || 0
          },
          {
            concepto: "Transferencia",
            monto: facturacion.transferencia || 0
          },
          {
            concepto: "Por definir (99)",
            monto: facturacion.formaPago99 || 0
          },
          {
            concepto: "Líneas de pago",
            monto: facturacion.lineasPago || 0
          },
          {
            concepto: "App",
            monto: facturacion.app || 0
          }
        ],
        totalPagosFacturados: facturacionTotal,
        conciliaciones: [
          {
            concepto: "Notas de Crédito",
            monto: conciliacion.notasCredito || 0,
            subcategoria: "MENOS"
          },
          {
            concepto: "Cancelaciones",
            monto: conciliacion.cancelaciones || 0,
            subcategoria: "MENOS"
          },
          {
            concepto: "Por definir (99)",
            monto: conciliacion.concecionarios || 0,
            subcategoria: "MENOS"
          },
          {
            concepto: "Facturación excepcional",
            monto: conciliacion.facturacionExcepcional || 0,
            subcategoria: "MENOS"
          },
          {
            concepto: "Facturación cobranza días anteriores",
            monto: conciliacion.facturacionDiasAnteriores || 0,
            subcategoria: "MENOS"
          },
          {
            concepto: "Recuperación de Cartera (99)",
            monto: conciliacionMas.recuperacionCartera || 0,
            subcategoria: "MAS"
          },
          {
            concepto: "Recibo Provisional (Cheques)",
            monto: conciliacionMas.reciboProvisional || 0,
            subcategoria: "MAS"
          },
          {
            concepto: "Cobranza pendiente de facturar",
            monto: conciliacionMas.pendienteFacturar || 0,
            subcategoria: "MAS"
          }
        ],
        totalConciliaciones: saldoConciliado,
        cobranzas: [
          {
            concepto: "Efectivo",
            monto: cobranza.efectivo || 0
          },
          {
            concepto: "Cheque",
            monto: cobranza.cheque || 0
          },
          {
            concepto: "CAT Visa/Mastercard",
            monto: cobranza.cargoAutomaticoVisaMc || 0
          },
          {
            concepto: "CAT American Express",
            monto: cobranza.cargoAutomaticoAmex || 0
          },
          {
            concepto: "TPV Visa/Mastercard",
            monto: cobranza.cargoDirectoVisaMc || 0
          },
          {
            concepto: "TPV American Express",
            monto: cobranza.cargoDirectoAmex || 0
          },

          {
            concepto: "Transferencia",
            monto: cobranza.transferencia || 0
          },
          {
            concepto: "Por definir (99)",
            monto: cobranza.formaPago99 || 0
          },
          {
            concepto: "Líneas de pago",
            monto: cobranza.lineasPago || 0
          },
          {
            concepto: "App",
            monto: cobranza.app || 0
          }
        ],
        totalCobranzas: cobranzaTotal,
        diferencia: 0 - saldoConciliado + cobranzaTotal,
        fechaGeneracion: `${year}-${month >= 10 ? month : 0 + month}-${
          day >= 10 ? day : 0 + day
        }T${hours >= 10 ? hours : 0 + hours}:${
          minutes >= 10 ? minutes : 0 + minutes
        }:${seconds >= 10 ? seconds : 0 + seconds}`
      },
      idClub,
      fechaInicio
    );
  };

  render() {
    const { idClub } = this.state.filters;
    const { clubsCatalog: clubs, data } = this.state;

    return (
      <Container className="p-0">
        <div className="row mt-3 mb-3">
          <div className="col">
            <p className={`${s.primaryTitle} w-100 m-0`}>Búsqueda</p>
          </div>
        </div>
        <Row>
          <Col xs={12} md={4} lg={3}>
            <BaseInput
              label="Club"
              name="club"
              id="club"
              type="select"
              placeholder="Seleccionar club"
              value={idClub}
              onChange={this.onChangeFilter("idClub")}
              size={"sm"}
              options={[{ value: "", label: "Seleccionar club" }].concat(
                clubs
                  ? clubs.map(option => ({
                      value: option.clubId,
                      label: option.nombre
                    }))
                  : []
              )}
            />
          </Col>
          <Col xs={12} md={4} lg={3}>
            <DatePicker
              label="Fecha"
              name={START_DATE_FIELDNAME}
              id={START_DATE_FIELDNAME}
              selected={this.state.filters[START_DATE_FIELDNAME]}
              onChange={this.onChangeDate(START_DATE_FIELDNAME)}
            />
          </Col>
          <Col xs={12} md={4} lg={3} className="mt-4">
            <Button
              size="sm"
              className={`float-right btn-block`}
              onClick={this.search}
              disabled={
                !this.state.filters.idClub ||
                !this.state.filters.fechaInicio ||
                this.state.loading
              }
            >
              {!!this.state.loading ? (
                <span>
                  <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />{" "}
                  Consultando
                </span>
              ) : (
                "Consultar"
              )}
            </Button>
          </Col>
        </Row>
        {!!data ? (
          <React.Fragment>
            {/*----------------------- FACTURACION -----------------------------------*/}

            <div className="row mt-3 mb-3">
              <div className="col">
                <p className={`${s.primaryTitle} w-100 m-0`}>Facturación</p>
              </div>
            </div>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Efectivo
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="EFECTIVO"
                  type="text"
                  id="EFECTIVO"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.efectivo)}
                  asCurrency={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Cheque
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="CHEQUE"
                  type="text"
                  id="CHEQUE"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.cheque)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                CAT Visa/Mastercard
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cargoAutomaticosVisaMc"
                  id="cargoAutomaticosVisaMc"
                  disabled={true}
                  value={formatToCurrency(
                    data.facturacion.cargoAutomaticoVisaMc
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                CAT American Express
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cargoAutomaticosAmex"
                  id="cargoAutomaticosAmex"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.cargoAutomaticoAmex)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                TPV Visa/Mastercard
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cargoDirectoVisaMc"
                  id="cargoDirectoVisaMc"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.cargoDirectoVisaMc)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                TPV American Express
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cargoDirectoAmex"
                  id="cargoDirectoAmex"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.cargoDirectoAmex)}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Transferencia
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="TRANSFERENCIA"
                  type="text"
                  id="TRANSFERENCIA"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.transferencia)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Por definir (99)
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  id="POR_DEFINIR_99"
                  name="POR_DEFINIR_99"
                  type="text"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.formaPago99)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Líneas de pago
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  id="conciliacionLineasPago"
                  name="conciliacionLineasPago"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.lineasPago)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                App
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  id="conciliacionApp"
                  name="conciliacionApp"
                  disabled={true}
                  value={formatToCurrency(data.facturacion.app)}
                />
              </Col>
            </Row>
            <Row>
              <Col
                xs={12}
                md={7}
                lg={7}
                className={`${s.parametro} ${s.black}`}
              >
                Total
              </Col>
              <Col xs={12} md={5} lg={5} className={s.parametro}>
                <MexicanCurrency quantity={data.facturacionTotal} />
              </Col>
            </Row>

            {/*----------------------- CONCILIACION -----------------------------------*/}
            <div className="row mt-3 mb-3">
              <div className="col">
                <p className={`${s.primaryTitle} w-100 m-0`}>Conciliación</p>
              </div>
            </div>
            <Row>
              <Col xs={12} md={8} lg={8} className="mt-4">
                MENOS
              </Col>
              <Col xs={12} md={4} lg={4} className="mt-4"></Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Notas de Crédito
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="NOTA_CREDITO"
                  type="text"
                  id="NOTA_CREDITO"
                  value={formatToCurrency(data.conciliacion.notasCredito)}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Cancelaciones
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="NOTA_CREDITO_DATOS_FISCALES"
                  type="text"
                  id="NOTA_CREDITO_DATOS_FISCALES"
                  value={formatToCurrency(data.conciliacion.cancelaciones)}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Por definir (99)
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="NOTA_CREDITO_COBRANZA_ERRONEA"
                  type="text"
                  id="NOTA_CREDITO_COBRANZA_ERRONEA"
                  value={formatToCurrency(data.conciliacion.concecionarios)}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Facturación excepcional
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="FACTURACION_EXCEPCIONAL"
                  type="text"
                  id="FACTURACION_EXCEPCIONAL"
                  value={formatToCurrency(
                    data.conciliacion.facturacionExcepcional
                  )}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Facturación cobranza días anteriores
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="FACTURACION_COBRANZA_DIAS_ANTERIORES"
                  type="text"
                  id="FACTURACION_COBRANZA_DIAS_ANTERIORES"
                  value={formatToCurrency(
                    data.conciliacion.facturacionDiasAnteriores
                  )}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={8} lg={8} className="mt-4">
                MAS
              </Col>
              <Col xs={12} md={4} lg={4} className="mt-4"></Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Recuperación de Cartera (99)
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="recuperacionCartera"
                  type="text"
                  id="recuperacionCartera"
                  value={formatToCurrency(
                    data.conciliacionMas.recuperacionCartera
                  )}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Recibo Provisional (Cheques)
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="reciboProvisional"
                  type="text"
                  id="reciboProvisional"
                  value={formatToCurrency(
                    data.conciliacionMas.reciboProvisional
                  )}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Cobranza pendiente de facturar
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  name="cobranzaPendienteFacturar"
                  type="text"
                  id="cobranzaPendienteFacturar"
                  value={formatToCurrency(
                    data.conciliacionMas.pendienteFacturar
                  )}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row>
              <Col
                xs={12}
                md={7}
                lg={7}
                className={`${s.parametro} ${s.black}`}
              >
                Saldo conciliado
              </Col>
              <Col xs={12} md={5} lg={5} className={s.parametro}>
                <MexicanCurrency
                  quantity={
                    data.facturacionTotal +
                    data.conciliacionMasTotal -
                    data.conciliacionTotal
                  }
                />
              </Col>
            </Row>

            {/*----------------------- COBRANZA -----------------------------------*/}
            <div className="row mt-3 mb-3">
              <div className="col">
                <p className={`${s.primaryTitle} w-100 m-0`}>Cobranza</p>
              </div>
            </div>

            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Efectivo
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cobranzaEfectivo"
                  id="cobranzaEfectivo"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.efectivo)}
                  asCurrency={true}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Cheque
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cobranzaCheque"
                  id="cobranzaCheque"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.cheque)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                CAT Visa/Mastercard
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cobranzacargoAutomaticosVisaMc"
                  id="cobranzacargoAutomaticosVisaMc"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.cargoAutomaticoVisaMc)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                CAT American Express
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cobranzacargoAutomaticosAmex"
                  id="cobranzacargoAutomaticosAmex"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.cargoAutomaticoAmex)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                TPV Visa/Mastercard
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cobranzacargoDirectoVisaMc"
                  id="cobranzacargoDirectoVisaMc"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.cargoDirectoVisaMc)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                TPV American Express
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cobranzacargoDirectoAmex"
                  id="cobranzacargoDirectoAmex"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.cargoDirectoAmex)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Transferencia
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  name="cobranzaTransferencia"
                  id="cobranzaTransferencia"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.transferencia)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Por definir (99)
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  id="cobranzaPD99"
                  name="cobranzaPD99"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.formaPago99)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                Líneas de pago
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  id="cobranzaLineasPago"
                  name="cobranzaLineasPago"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.lineasPago)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={7} lg={7} className={s.parametro}>
                App
              </Col>
              <Col xs={12} md={5} lg={5}>
                <BaseInput
                  type="text"
                  id="cobranzaApp"
                  name="cobranzaApp"
                  disabled={true}
                  value={formatToCurrency(data.cobranza.app)}
                />
              </Col>
            </Row>
            <Row>
              <Col
                xs={12}
                md={7}
                lg={7}
                className={`${s.parametro} ${s.black}`}
              >
                Total
              </Col>
              <Col xs={12} md={5} lg={5} className={s.parametro}>
                <MexicanCurrency quantity={data.cobranzaTotal} />
              </Col>
            </Row>

            <Row>
              <Col className="mt-5 mb-5">
                <Button
                  size="sm"
                  className={`float-right btn-block`}
                  onClick={this.generarPDF}
                >
                  Generar PDF
                </Button>
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          ""
        )}
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(ConciliacionCashCutReport));
